import React, { useState } from 'react';
import { LuUser, LuShoppingCart, LuSearch } from 'react-icons/lu';
import { Link, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import logo from '../assets/logo.png';

const Navbar = ({ isAuthenticated = true }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const totalQuantity = useSelector((state) => state.cart.totalQuantity);
  const location = useLocation();

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const getActiveClass = (path) => {
    return location.pathname === path
      ? 'text-black bg-gray-100'
      : 'text-gray-800 hover:bg-gray-100 hover:text-black';
  };

  return (
    <nav className="bg-white fixed top-0 w-screen py-2 z-[99] shadow-sm">
      <div className="mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          <div className="flex items-center">
            <div className="flex-shrink-0">
              <Link to="/" className="text-black font-bold text-xl">
                <img src={logo} className="h-[40px] w-auto" alt="" />
              </Link>
            </div>
            <div className="ml-10 hidden md:block">
              <div className="flex flex-row items-baseline gap-6">
                <Link
                  to="/"
                  className={`px-4 py-2 text-md font-medium ${getActiveClass('/')}`}
                >
                  Home
                </Link>
                <Link
                  to="/shop"
                  className={`px-4 py-2 text-md font-medium ${getActiveClass('/shop')}`}
                >
                  Shop
                </Link>
                <Link
                  to="/story"
                  className={`px-4 py-2 text-md font-medium ${getActiveClass('/story')}`}
                >
                  Our Story
                </Link>
                <Link
                  to="/contact"
                  className={`px-4 py-2 text-md font-medium ${getActiveClass('/contact')}`}
                >
                  Contact Us
                </Link>
              </div>
            </div>
          </div>
          <div className="flex items-center">
            <div className="flex-1 mr-3 flex justify-center px-2 lg:ml-6 lg:justify-end hidden md:block">
              <div className="max-w-lg w-full lg:max-w-xs">
                <label htmlFor="search" className="sr-only">
                  Search
                </label>
                <div className="relative">
                  <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                    <LuSearch className="h-5 w-5 text-gray-400" />
                  </div>
                  <input
                    id="search"
                    name="search"
                    className="block w-full pl-10 pr-3 py-3 border border-transparent leading-5 bg-gray-100 text-gray-800 placeholder-gray-400 focus:outline-none focus:bg-gray-200 focus:border-white focus:ring-white focus:text-gray-900 sm:text-md"
                    placeholder="Search"
                    type="search"
                  />
                </div>
              </div>
            </div>
            <div className="ml-4 gap-[20px] flex items-center md:ml-5">
              <Link
                to="/cart"
                className="text-gray-400 hover:text-gray-500 relative hidden md:block"
              >
                <LuShoppingCart className="h-6 w-6" />
                <span className="absolute top-0 right-0 inline-flex items-center justify-center px-2 py-1 text-xs font-bold leading-none text-red-100 transform translate-x-1/2 -translate-y-1/2 bg-red-600 rounded-full">
                  {totalQuantity}
                </span>
              </Link>
              <div className="ml-3 relative hidden md:block">
                {isAuthenticated ? (
                  <Link
                    to="/profile"
                    className="text-gray-400 hover:text-gray-500"
                  >
                    <LuUser className="h-6 w-6" />
                  </Link>
                ) : (
                  <Link
                    to="/signin"
                    className="text-white px-4 py-3 bg-primary text-md font-medium"
                  >
                    Sign In
                  </Link>
                )}
              </div>
            </div>
          </div>
          <div className="mr-2 flex md:hidden">
            <button
              onClick={toggleMenu}
              type="button"
              className="inline-flex items-center justify-center p-2 text-gray-400 hover:text-black hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-800 focus:ring-white"
              aria-controls="mobile-menu"
              aria-expanded="false"
            >
              <span className="sr-only">Open main menu</span>
              {isMenuOpen ? (
                <svg
                  className="block h-6 w-6"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  aria-hidden="true"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              ) : (
                <svg
                  className="block h-6 w-6"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  aria-hidden="true"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M4 6h16M4 12h16M4 18h16"
                  />
                </svg>
              )}
            </button>
          </div>
        </div>
      </div>

      <div className={`md:hidden ${isMenuOpen ? 'block' : 'hidden'}`} id="mobile-menu">
        <div className="px-2 pt-2 pb-3 mb-5 mt-5 space-y-1 sm:px-3">
          <div className="flex-1 mr-3 flex justify-center px-2 lg:ml-6 lg:justify-end">
            <div className="max-w-lg w-full lg:max-w-xs">
              <label htmlFor="search" className="sr-only">
                Search
              </label>
              <div className="relative">
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                  <LuSearch className="h-5 w-5 text-gray-400" />
                </div>
                <input
                  id="search"
                  name="search"
                  className="block w-full pl-10 pr-3 py-3 border border-transparent leading-5 bg-gray-100 text-gray-800 placeholder-gray-400 focus:outline-none focus:bg-gray-200 focus:border-white focus:ring-white focus:text-gray-900 sm:text-md"
                  placeholder="Search"
                  type="search"
                />
              </div>
            </div>
          </div>
          <br />
          <Link
            to="/"
            className={`block px-3 py-2 text-base font-medium ${getActiveClass('/')}`}
          >
            Home
          </Link>
          <Link
            to="/shop"
            className={`block px-3 py-2 text-base font-medium ${getActiveClass('/shop')}`}
          >
            Shop
          </Link>
          <Link
            to="/story"
            className={`block px-3 py-2 text-base font-medium ${getActiveClass('/story')}`}
          >
            Our Story
          </Link>
          <Link
            to="/contact"
            className={`block px-3 py-2 text-base font-medium ${getActiveClass('/contact')}`}
          >
            Contact Us
          </Link>
          <Link
            to="/profile"
            className={`block px-3 py-2 text-base font-medium ${getActiveClass('/profile')}`}
          >
            Profile
          </Link>
          <div className="h-3 w-full"></div>
          <Link
            to="/cart"
            className="text-gray-800 relative px-3 py-0"
          >
            Cart
            <span className="absolute top-0 right-0 inline-flex items-center justify-center px-2 py-1 text-xs font-bold leading-none text-red-100 transform translate-x-1/2 -translate-y-1/2 bg-red-600 rounded-full">
              {totalQuantity}
            </span>
          </Link>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;